import { Component, OnInit, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '@modal/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'app-info-button',
  templateUrl: './info-button.component.html',
  styleUrls: ['./info-button.component.scss'],
})
export class InfoButtonComponent implements OnInit {
  @Input()
  public tooltip: string = '';

  constructor(private matDialog: MatDialog) {}

  ngOnInit() {}

  openDialog() {
    const confirmConfig = {
      text: this.tooltip,
      buttons: [
        {
          text: 'OK',
          value: 'abort',
        },
      ],
    };

    this.matDialog.open(ConfirmDialogComponent, {
      data: confirmConfig,
      disableClose: false,
      panelClass: ConfirmDialogComponent.cssClass,
    });
  }
}
